export default class Voice {
    constructor(carrier, modulators, slotNumber) {
        this.carrier = carrier;
        this.modulators = modulators;
        this.slotNumber = slotNumber;
        this.voiceNumber = slotNumber;
    }
}
